import React, {useState} from 'react';
//material
import {Card, CardContent, withStyles, Table, TableBody, TableHead, TableRow, TableCell, Collapse, IconButton} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
import {ExpandMore} from '@material-ui/icons';
//styles
import styles from './results-card-styles';

const ResultsCardView = (props) => {
  const {classes, isLoading, results} = props;
  const [expanded, setExpanded] = useState(false);

  return (
    <Card>
      <CardContent className={classes.cardContent}>
        {
          isLoading ?
            <Skeleton height={40} width={'60%'} /> :
            <div className={classes.title}>
              Results
            </div>
        }

        {
          !isLoading &&
          <IconButton
            className={classes.expandButton + ' ' + (expanded ? classes.expandOpen : '')}
            onClick={() => setExpanded(!expanded)}
            size={'small'}>
            <ExpandMore />
          </IconButton>
        }

        <Collapse in={expanded} timeout='auto' unmountOnExit>
          {
            !isLoading && results.length > 0 &&
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Round</TableCell>
                  <TableCell>Opponent</TableCell>
                  <TableCell>Club</TableCell>
                  <TableCell>Result</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {
                  results.map((r, i) => (
                    <TableRow key={i}>
                      <TableCell>#{r.roundNumber}</TableCell>
                      <TableCell>{r.opponentName ? r.opponentName : 'none'}</TableCell>
                      <TableCell>{r.clubName ? r.clubName : ''}</TableCell>
                      <TableCell>
                        <div>{r.isBye ? 'BYE' : r.result}</div>
                        <div>{r.isWinner ? 'WON' : 'LOST'}</div>
                      </TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          }
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles) (ResultsCardView);
